// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b4c7288","552":"f5e61937","861":"cec14b7f"}[chunkId] + ".chunk.js";
};